import { take, fork, put, call, cancel } from "redux-saga/effects";
import { resetPasswordSuccess, resetPasswordFail } from "store/actions/login";
import { showSuccessNotification } from "store/actions/notification";
import types from "store/actionTypes";
import { callApi } from "store/sagas/callApi";

function* processResetPassword({ email, history }) {
  try {
    const response = yield call(callApi, `resetPassword`, "PATCH", { email });
    const { data } = response;
    
    if (data.success) {
      yield put(resetPasswordSuccess());
      yield put(showSuccessNotification("Password reset instructions have been sent to your email"));
      if (history) {
        history.push("/login");
      }
    } else {
      yield put(resetPasswordFail(data.message || "Failed to reset password"));
    }
  } catch (e) {
    yield put(
      resetPasswordFail(e?.response?.data?.error?.message || e.message || "Failed to reset password")
    );
  }
}

export function* watchResetPassword() {
  let forked = null;
  while (true) {
    const action = yield take(types.RESET_PASSWORD_REQUEST);
    if (forked) yield cancel(forked);
    forked = yield fork(processResetPassword, action);
  }
}
